import React from 'react';
import PropTypes from 'prop-types';
import EditIcon from './edit_icon';
import vahoy from '../../javascript/vahoy';

class ContactInfos extends React.Component {
  onClickEditIcon = (infoType, model) => () => {
    const { isEditable, toggleAddOrEditAddress, toggleAddOrEditContactInfo } = this.props;

    if (!isEditable) {
      return;
    }

    if (infoType == 'address') {
      toggleAddOrEditAddress();
    } else {
      toggleAddOrEditContactInfo(infoType, model);
    }
  };

  trackClicks = (clickType) => {
    vahoy.track(`Reporter/ContactInfos#clickContactInfoLink_${clickType}`);
  };

  constructUrl(urlType, value) {
    if (urlType == 'facebook') {
      if (/^http(s?:?)\/\//i.test(value)) {
        return value;
      }
      if (/fb.com|facebook.com/i.test(value)) {
        return `https://${value}`.replace(/\/{3,}/, '//');
      }
      return `https://facebook.com/${value}`;
    }
    if (urlType == 'linkedin') {
      if (/^http(s?:?)\/\//i.test(value)) {
        return value;
      }
      if (/linkedin.com/i.test(value)) {
        return `https://${value}`.replace(/\/{3,}/, '//');
      }
      return `https://linkedin.com/${value}`;
    }
    if (urlType == 'instagram') {
      if (/^http(s?:?)\/\//i.test(value)) {
        return value;
      }
      if (/instagram.com/i.test(value)) {
        return `https://${value}`.replace(/\/{3,}/, '//');
      }
      return `https://instagram.com/${value.replace(/^@/, '')}`;
    }
    if (urlType == 'bluesky') {
      if (/^http(s?:?)\/\//i.test(value)) {
        return value;
      }
      if (/bsky.app/i.test(value)) {
        return `https://${value}`.replace(/\/{3,}/, '//');
      }
      return `https://bsky.app/profile/${value.replace(/^@/, '')}`;
    }
    return value;
  }

  renderEditIcon(onClickFn, additionalClasses, optionalText = null) {
    const { isEditable } = this.props;

    return (
      <EditIcon
        isEditable={isEditable}
        optionalText={optionalText}
        onClickFn={onClickFn}
        className={additionalClasses}
      />
    );
  }

  render() {
    const { contactInfos = [], addressValue } = this.props;

    let twitter = contactInfos.find((ci) => {
      const r = ci.attributes.info_type == 'twitter' && ci.attributes.primary == 'true';
      return r;
    });
    twitter = twitter || contactInfos.find((ci) => ci.attributes.info_type == 'twitter');
    let facebook = contactInfos.find((ci) => {
      const r = ci.attributes.info_type == 'facebook' && ci.attributes.primary == 'true';
      return r;
    });
    facebook = facebook || contactInfos.find((ci) => ci.attributes.info_type == 'facebook');
    let linkedin = contactInfos.find((ci) => {
      const r = ci.attributes.info_type == 'linkedin' && ci.attributes.primary == 'true';
      return r;
    });
    linkedin = linkedin || contactInfos.find((ci) => ci.attributes.info_type == 'linkedin');
    let instagram = contactInfos.find((ci) => {
      const r = ci.attributes.info_type == 'instagram' && ci.attributes.primary == 'true';
      return r;
    });
    instagram = instagram || contactInfos.find((ci) => ci.attributes.info_type == 'instagram');
    let bluesky = contactInfos.find((ci) => {
      const r = ci.attributes.info_type == 'bluesky' && ci.attributes.primary == 'true';
      return r;
    });
    bluesky = bluesky || contactInfos.find((ci) => ci.attributes.info_type == 'bluesky');

    const addressInfo = addressValue && (
      <li>
        <address className="mb-0">
          <i className="fa-solid fa-location-dot me-2" />
          {addressValue} {this.renderEditIcon(this.onClickEditIcon('address'), 'ms-2 p-0 edit-location-btn')}
        </address>
      </li>
    );

    const twitterInfo = twitter && (
      <li className="mt-1">
        <i className="me-2 fa-brands fa-x-twitter" />
        <a
          target="_blank"
          rel="noopener noreferrer"
          href={`https://twitter.com/${twitter.attributes.value}`}
          className="text-primary"
          onClick={() => this.trackClicks('twitter')}
        >
          {twitter.attributes.value}
        </a>
        {this.renderEditIcon(this.onClickEditIcon('twitter', twitter), 'ms-2 p-0 edit-twitter-btn')}
      </li>
    );

    const facebookInfo = facebook && (
      <li className="mt-2">
        <i className="me-2 fa-brands fa-facebook-f" />
        <a
          target="_blank"
          rel="noopener noreferrer"
          href={this.constructUrl('facebook', facebook.attributes.value)}
          className="text-primary"
          onClick={() => this.trackClicks('facebook')}
        >
          {facebook.attributes.value.replace(/^[a-z0-9:/.]+facebook.com\//i, '')}
        </a>
        {this.renderEditIcon(this.onClickEditIcon('facebook', facebook), 'ms-2 p-0 edit-facebook-btn')}
      </li>
    );

    const linkedinInfo = linkedin && (
      <li className="mt-1">
        <i className="me-2 fa-brands fa-linkedin-in" />
        <a
          target="_blank"
          rel="noopener noreferrer"
          href={this.constructUrl('linkedin', linkedin.attributes.value)}
          className="text-primary"
          onClick={() => this.trackClicks('linkedin')}
        >
          {linkedin.attributes.value.replace(/^[a-z0-9:/.]+linkedin.com\//i, '')}
        </a>
        {this.renderEditIcon(this.onClickEditIcon('linkedin', linkedin), 'ms-2 p-0 edit-linkedin-btn')}
      </li>
    );

    const instagramInfo = instagram && (
      <li className="mt-1">
        <i className="me-2 fa-brands fa-instagram" />
        <a
          target="_blank"
          rel="noopener noreferrer"
          href={this.constructUrl('instagram', instagram.attributes.value)}
          className="text-primary"
          onClick={() => this.trackClicks('instagram')}
        >
          {instagram.attributes.value.replace(/^[a-z0-9:/.]+instagram.com\//i, '')}
        </a>
        {this.renderEditIcon(this.onClickEditIcon('instagram', instagram), 'ms-2 p-0 edit-instagram-btn')}
      </li>
    );

    const blueskyInfo = bluesky && (
      <li className="mt-1">
        <i className="me-2 fa-brands fa-bluesky" />
        <a
          target="_blank"
          rel="noopener noreferrer"
          href={this.constructUrl('bluesky', bluesky.attributes.value)}
          className="text-primary"
          onClick={() => this.trackClicks('bluesky')}
        >
          {bluesky.attributes.value.replace(/^[a-z0-9:/.]+bsky.app\/profile\//i, '')}
        </a>
        {this.renderEditIcon(this.onClickEditIcon('bluesky', bluesky), 'ms-2 p-0 edit-bluesky-btn')}
      </li>
    );

    return (
      <ul className="list-unstyled mt-3">
        {addressInfo}
        {twitterInfo}
        {linkedinInfo}
        {facebookInfo}
        {instagramInfo}
        {blueskyInfo}
      </ul>
    );
  }
}

ContactInfos.propTypes = {
  isEditable: PropTypes.bool,
  addressValue: PropTypes.string,
  contactInfos: PropTypes.arrayOf(Object).isRequired,
  toggleAddOrEditContactInfo: PropTypes.func,
  toggleAddOrEditAddress: PropTypes.func,
};

ContactInfos.defaultProps = {
  isEditable: undefined,
  addressValue: '',
  toggleAddOrEditContactInfo: undefined,
  toggleAddOrEditAddress: undefined,
};

export default ContactInfos;
